export const config = {
  protocol: 'https',
  domain: 'etcsci.com'
}